import React from "react";
import { createRoot } from "react-dom/client";
//import './index.css';
//import 'bootstrap/dist/css/bootstrap.min.css'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import "./assets/styles/bootstrap.custom.css";
import "./assets/styles/index.css";
import PrivateRoute from "./components/PrivateRoute";

// Route-level code splitting: each screen is fetched only when its route is
// visited instead of all being bundled into the initial JS payload.
const HomeScreen = React.lazy(() => import("./screens/HomeScreen"));
const LoginScreen = React.lazy(() => import("./screens/LoginScreen"));
const RegisterScreen = React.lazy(() => import("./screens/RegisterScreen"));
const AttendanceScreen = React.lazy(() => import("./screens/AttendanceScreen"));
const UsersScreen = React.lazy(() => import("./screens/UsersScreen"));
const MyProfileScreen = React.lazy(() => import("./screens/MyProfileScreen"));
const UserProfileScreen = React.lazy(() =>
  import("./screens/UserProfileScreen")
);
const AttendanceListScreen = React.lazy(() =>
  import("./screens/AttendanceListScreen")
);
const UserRegistrationScreen = React.lazy(() =>
  import("./screens/UserRegistrationScreen")
);
const DashBoard = React.lazy(() => import("./screens/DashBoard"));
const VisitorsScreen = React.lazy(() => import("./screens/VisitorsScreen"));
const AttendanceScreenFromMobile = React.lazy(() =>
  import("./screens/AttendanceScreenFromMobile")
);
const QrCodeScreen = React.lazy(() => import("./screens/QrCodeScreen"));
const InActiveUsersScreen = React.lazy(() =>
  import("./screens/InActiveUsersScreen")
);
const PaymentListScreen = React.lazy(() =>
  import("./screens/PaymentListScreen")
);
const AssociateRegisterScreen = React.lazy(() =>
  import("./screens/AssociateRegisterScreen")
);
const AssociatesScreen = React.lazy(() => import("./screens/AssociatesScreen"));
const AssociateProfileScreen = React.lazy(() =>
  import("./screens/AssociateProfileScreen")
);
const ChangePasswordScreen = React.lazy(() =>
  import("./screens/ChangePasswordScreen")
);
const SubsExpiredUsersScreen = React.lazy(() =>
  import("./screens/SubsExpiredUsersScreen")
);
const UsersUploadScreen = React.lazy(() =>
  import("./screens/UsersUploadScreen")
);
const UserSelfRegistrationScreen = React.lazy(() =>
  import("./screens/UserSelfRegistrationScreen")
);
const QrCodeForRegScreen = React.lazy(() =>
  import("./screens/QrCodeForRegScreen")
);
const PendingRegsScreen = React.lazy(() =>
  import("./screens/PendingRegsScreen")
);
const UserSelfProfileScreen = React.lazy(() =>
  import("./screens/UserSelfProfileScreen")
);
const AccountsScreen = React.lazy(() => import("./screens/AccountsScreen"));
const UserPaymentsScreen = React.lazy(() =>
  import("./screens/UserPaymentsScreen")
);
const AttendancesOfUserScreen = React.lazy(() =>
  import("./screens/AttendancesOfUserScreen")
);
const NumberForUsersScreen = React.lazy(() =>
  import("./screens/NumberForUsersScreen")
);
// import QRScanner from "./screens/QRScanner";
const NumberForUsersAppScreen = React.lazy(() =>
  import("./screens/NumberForUsersAppScreen")
);
const GymProfileScreen = React.lazy(() => import("./screens/GymProfileScreen"));
const GymPaymentUpdateScreen = React.lazy(() =>
  import("./screens/GymPaymentUpdateScreen")
);
const CustomerDetailsScreen = React.lazy(() =>
  import("./screens/CustomerDetailsScreen")
);
const ContactUsScreen = React.lazy(() => import("./screens/ContactUsScreen"));
const PrivacyPolicyScreen = React.lazy(() =>
  import("./screens/PrivacyPolicyScreen")
);
const ForgotPasswordScreen = React.lazy(() =>
  import("./screens/ForgotPasswordScreen")
);
const WsMessageListScreen = React.lazy(() =>
  import("./screens/WsMessageListScreen")
);
const WhatsAppAdsScreen = React.lazy(() =>
  import("./screens/WhatsAppAdsScreen")
);
const WsMessageAdsListScreen = React.lazy(() =>
  import("./screens/WsMessageAdsListScreen")
);
const EquipmentsScreen = React.lazy(() => import("./screens/EquipmentsScreen"));
const SupplementSalesScreen = React.lazy(() =>
  import("./screens/SupplementSalesScreen")
);
const TrendsScreen = React.lazy(() => import("./screens/TrendsScreen"));
const AssociateAttendanceScreen = React.lazy(() =>
  import("./screens/AssociateAttendanceScreen")
);
const AssociateAttendanceFromMobile = React.lazy(() =>
  import("./screens/AssociateAttendanceFromMobile")
);
const EditAttendancePageScreen = React.lazy(() =>
  import("./screens/EditAttendancePageScreen")
);
const AllUsersScreen = React.lazy(() => import("./screens/AllUsersScreen"));
const DownloadAppScreen = React.lazy(() =>
  import("./screens/DownloadAppScreen")
);
const PackagesScreen = React.lazy(() => import("./screens/PackagesScreen"));
const SubscriptionsScreen = React.lazy(() =>
  import("./screens/SubscriptionsScreen")
);
const ShowToVisitorsScreen = React.lazy(() =>
  import("./screens/ShowToVisitorsScreen")
);
const VisitorInputScreen = React.lazy(() =>
  import("./screens/VisitorInputScreen")
);
const DetailsToVisitorsScreen = React.lazy(() =>
  import("./screens/DetailsToVisitorsScreen")
);
const PtUsersScreen = React.lazy(() => import("./screens/PtUsersScreen"));
const VisitorsRemainderScreen = React.lazy(() =>
  import("./screens/VisitorsRemainderScreen")
);
const TodaysExpiringMembers = React.lazy(() =>
  import("./screens/TodaysExpiringMembers")
);
const UploadUserToEsslDeviceScreen = React.lazy(() =>
  import("./screens/UploadUserToEsslDeviceScreen")
);
const PendingsHistoryScreen = React.lazy(() =>
  import("./screens/PendingsHistoryScreen")
);

const PackageSelectScreen = React.lazy(() =>
  import("./screens/PackageSelectScreen")
);
const GetSelfDetailsScreen = React.lazy(() =>
  import("./screens/GetSelfDetailsScreen")
);
const SelfRenewalScreen = React.lazy(() =>
  import("./screens/SelfRenewalScreen")
);
const MemberSelfSubscriptionScreen = React.lazy(() =>
  import("./screens/MemberSelfSubscriptionScreen")
);
const WorkoutPlanScreen = React.lazy(() =>
  import("./screens/WorkoutPlanScreen")
);
const WorkoutPlanDetailsScreen = React.lazy(() =>
  import("./screens/WorkoutPlanDetailsScreen")
);
const DietPlanDetailsScreen = React.lazy(() =>
  import("./screens/DietPlanDetailsScreen")
);
const DietPlannerScreen = React.lazy(() =>
  import("./screens/DietPlannerScreen")
);
const MemeberDetailsScreen = React.lazy(() =>
  import("./screens/MemeberDetailsScreen")
);
const ThemeColorPicker = React.lazy(() => import("./screens/ThemeColorPicker"));
const FunActivities = React.lazy(() => import("./screens/FunActivities"));
const WsChatScreen = React.lazy(() => import("./screens/WsChatScreen"));
const CashfreePayButton = React.lazy(() =>
  import("./components/CashfreePayButton")
);
const GymEventsScreen = React.lazy(() => import("./screens/GymEventsScreen"));
const MemberFeedbackScreen = React.lazy(() =>
  import("./screens/MemberFeedbackScreen")
);
const QRForMemberAppScreen = React.lazy(() =>
  import("./screens/QRForMemberAppScreen")
);
const QrCodeForPaymentScreen = React.lazy(() =>
  import("./screens/QrCodeForPaymentScreen")
);
const GymPaymentsScreen = React.lazy(() =>
  import("./screens/GymPaymentsScreen")
);
const UserAnalyticsScreen = React.lazy(() =>
  import("./screens/UserAnalyticsScreen")
);
const SelfLoginScreen = React.lazy(() => import("./screens/SelfLoginScreen"));
const RemindersScreen = React.lazy(() => import("./screens/RemindersScreen"));
const PaymentLinkScreen = React.lazy(() => import("./screens/PaymentLinkScreen"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicyScreen />} />
      <Route path="/resetPassword" element={<ForgotPasswordScreen />} />
      <Route path="/selfLogin" element={<SelfLoginScreen />} />
      {/* Public: the renewal token in the path is the credential. Sits
          OUTSIDE PrivateRoute so it opens with no session. */}
      <Route path="/gymProfile/:token" element={<PaymentLinkScreen />} />
      {/* <Route path="/qrscanner" element={<QRScanner />} /> */}
      <Route path="/usersAtGym/:id" element={<NumberForUsersScreen />} />
      <Route path="/usersAtGymApp" element={<NumberForUsersAppScreen />} />
      <Route path="/register" element={<RegisterScreen />} />
      <Route
        path="/attendanceFromMobile/:gymUid"
        element={<AttendanceScreenFromMobile />}
      />{" "}
      <Route
        path="/visitorInputScreen/:gymUid"
        element={<VisitorInputScreen />}
      />
      <Route
        path="/detailsToVisitorsScreen/:gymUid"
        element={<DetailsToVisitorsScreen />}
      />
      <Route path="/markAttendance" element={<AttendanceScreen />} />{" "}
      <Route
        path="/associateAttendanceFromMobile/:gymUid"
        element={<AssociateAttendanceFromMobile />}
      />
      <Route
        path="/userSelfRegistration"
        element={<UserSelfRegistrationScreen />}
      />
      <Route
        path="/memberSelfSubscription/:gymUid"
        element={<MemberSelfSubscriptionScreen />}
      />
      <Route path="/selectPackage" element={<PackageSelectScreen />} />
      <Route path="/selfDetail" element={<GetSelfDetailsScreen />} />
      <Route
        path="/selfDetail/:encodedId?"
        element={<GetSelfDetailsScreen />}
      />
      <Route path="/selectPackage" element={<PackageSelectScreen />} />
      <Route path="/selfRenewal" element={<SelfRenewalScreen />} />
      <Route path="/yourDetails" element={<MemeberDetailsScreen />} />
      <Route path="" element={<PrivateRoute />}>
        <Route
          path="/updateAttendancePageScreen"
          element={<EditAttendancePageScreen />}
        ></Route>
        <Route path="/funActs" element={<FunActivities />}></Route>
        <Route path="/users/:id" element={<UserProfileScreen />}></Route>
        <Route path="/users" element={<UsersScreen />}></Route>
        <Route path="/" element={<DashBoard />}></Route>
        <Route path="/allUsers" element={<AllUsersScreen />}></Route>
        <Route path="/downloadApps" element={<DownloadAppScreen />}></Route>
        <Route path="/regPendingUsers" element={<PendingRegsScreen />}></Route>
        <Route
          path="/usersSelfProfile/:id"
          element={<UserSelfProfileScreen />}
        ></Route>
        <Route path="/subsExpiredUsers" element={<SubsExpiredUsersScreen />} />
        <Route path="/subscriptions" element={<SubscriptionsScreen />} />
        <Route path="/ptUsers" element={<PtUsersScreen />} />
        <Route path="/trends" element={<TrendsScreen />} />
        <Route path="/packages" element={<PackagesScreen />} />
        <Route path="/userPayments/:id" element={<UserPaymentsScreen />} />
        <Route
          path="/attendanceList"
          element={<AttendanceListScreen />}
        ></Route>
        <Route path="/home" element={<HomeScreen />}></Route>
        <Route path="/profile" element={<MyProfileScreen />}></Route>
        <Route path="/gymProfile" element={<GymProfileScreen />}></Route>
        <Route path="/gymPayments" element={<GymPaymentsScreen />} />
        <Route
          path="/customersDetails"
          element={<CustomerDetailsScreen />}
        ></Route>
        <Route
          path="/gymPaymentUpdate"
          element={<GymPaymentUpdateScreen />}
        ></Route>
        <Route path="/dashboard" element={<DashBoard />}></Route>
        <Route path="/reminders" element={<RemindersScreen />}></Route>
        <Route path="/equipments" element={<EquipmentsScreen />}></Route>
        <Route
          path="/supplementSales"
          element={<SupplementSalesScreen />}
        ></Route>
        <Route
          path="/wsMessageAdsList"
          element={<WsMessageAdsListScreen />}
        ></Route>
        <Route path="/accounts" element={<AccountsScreen />}></Route>
        <Route
          path="/visitorsReminder"
          element={<VisitorsRemainderScreen />}
        ></Route>
        <Route
          path="/todaysExpiringMembers"
          element={<TodaysExpiringMembers />}
        ></Route>
        <Route path="/visitors" element={<VisitorsScreen />}></Route>
        <Route path="/qrCode" element={<QrCodeScreen />} />
        <Route path="/memberAppQrCode" element={<QRForMemberAppScreen />} />
        <Route path="/contactUs" element={<ContactUsScreen />} />
        <Route path="/inactiveusers" element={<InActiveUsersScreen />} />
        <Route path="/payments" element={<PaymentListScreen />} />
        <Route path="/pendingPayments" element={<PendingsHistoryScreen />} />
        <Route
          path="/associateRegister"
          element={<AssociateRegisterScreen />}
        />
        <Route path="/associates" element={<AssociatesScreen />} />
        <Route
          path="/associatesAttendance"
          element={<AssociateAttendanceScreen />}
        />
        <Route path="/associate/:id" element={<AssociateProfileScreen />} />
        <Route
          path="/userRegistration"
          element={<UserRegistrationScreen />}
        ></Route>
        <Route path="/qrcodeRegister" element={<QrCodeForRegScreen />} />
        <Route path="/showToVisitors" element={<ShowToVisitorsScreen />} />
        <Route path="/promotionalMessage" element={<WhatsAppAdsScreen />} />
        <Route path="/uploadUsers" element={<UsersUploadScreen />} />
        <Route path="/changePassword" element={<ChangePasswordScreen />} />

        <Route path="/workoutPlan" element={<WorkoutPlanScreen />} />
        <Route
          path="/workoutPlanDetails"
          element={<WorkoutPlanDetailsScreen />}
        />
        <Route path="/dietPlanDetails" element={<DietPlanDetailsScreen />} />
        <Route path="/dietPlan" element={<DietPlannerScreen />} />

        <Route
          path="/attendanceList"
          element={<AttendanceListScreen />}
        ></Route>
        <Route
          path="/attendancesOfUser/:id"
          element={<AttendancesOfUserScreen />}
        ></Route>
        <Route
          path="/whatsAppMessages"
          element={<WsMessageListScreen />}
        ></Route>
        <Route path="/wsChat" element={<WsChatScreen />} />
        <Route
          path="/uploadUserToEsslDevice"
          element={<UploadUserToEsslDeviceScreen />}
        ></Route>
        <Route path="/changeAppColors" element={<ThemeColorPicker />} />
        <Route path="/cashfreePayScreen" element={<CashfreePayButton />} />
        <Route path="/events" element={<GymEventsScreen />} />
        <Route path="/feedback" element={<MemberFeedbackScreen />} />
        <Route
          path="/paymentQrCode"
          element={<QrCodeForPaymentScreen />}
        ></Route>
        <Route path="/userSmartAnalytics" element={<UserAnalyticsScreen />} />
      </Route>
    </Route>
  )
);

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
